<template>
	<div class="fixed pin flex items-center z-modal">
		<div class="absolute pin bg-gray900 opacity-90" @click.self="close"></div>

		<div class="relative w-full flex justify-center items-center">
		
			<div class="flex flex-col items-center w-full" @click.self="close">
			
				<div class="w-full text-center" @touchstart="setTouchstart($event)" @touchend="setTouchend($event)">
					<img class="gallery-image rounded shadow-dark" :src="image" :alt="'Image #' + (photoIndex + 1) + ' detailing the property'">
				</div>

				<div class="flex justify-between items-center py-40 max-w-3/4">
				
					<button
						@click.stop
						@click="prevPhoto"
						class="bg-transparent text-white outline-none"
            aria-label="Previous Photo"
					><img src='/assets/img/right-arrow.svg' alt="An arrow that points backwards, clicking leads to the previous photo"></button>					
					
					<div class="px-60 text-white">Image {{ photoIndex + 1 }} of {{ photos.length }}</div>

					<button
						@click.stop
						@click="nextPhoto"
						class="bg-transparent text-white outline-none"
            aria-label="Next Photo"
					><img src='/assets/img/left-arrow.svg' alt="An arrow that points forwards, clicking leads to the next photo"></button>
				</div>
				
			</div>
		</div>

		<!-- Close Button -->
		<div class="absolute pin-t pin-r p-30">
			<button class="bg-transparent text-white" @click="close" aria-label="Close"><img src='/assets/img/x.svg' alt="An image that looks like an X, on click it closes the gallery"></button>
		</div>
	</div>
</template>

<style scoped>
	.gallery-image{
		max-height: 80vh;
	}
</style>

<script>
// Commercial and association gallery modal with keyboard and swipe navigation.
export default {
	props: {
		photos: {
			type: Array,
			required: true
		},
		photoIndex: {
			type: Number,
			required: true
		},
		windowSize: {
			type: String
		}
	},
	emits: ['close', 'prev-photo', 'next-photo'],
	data () {
        return {
            touchstartX: 0,
            touchendX: 0,
        }
    },
	mounted() {
		window.addEventListener('keyup', this.handleKeyPress)
	},
	beforeUnmount() {
		window.removeEventListener('keyup', this.handleKeyPress)
	},
	computed: {
		image() {
			return this.photos[this.photoIndex];
		}
	},
	methods: {
		handleKeyPress(e) {
			// Left arrow
			if (e.keyCode == 37) {
				this.prevPhoto();

			// Right arrow
			} else if (e.keyCode == 39) {
				this.nextPhoto();
			
			// Esc key
			} else if (e.keyCode == 27) {
				this.close();
			}
		},
		close() {
			this.$emit('close');
		},
		prevPhoto() {
			this.$emit('prev-photo');
		},
		nextPhoto() {
			this.$emit('next-photo');
		},
		swipeEnd() {
			if (this.touchendX < this.touchstartX) {
				this.$emit('next-photo');
			}
			if (this.touchendX > this.touchstartX) {
				this.$emit('prev-photo');
			}
		},
		setTouchstart(event){
			this.touchstartX = event.changedTouches[0].screenX;
		},
		setTouchend(event){
			this.touchendX = event.changedTouches[0].screenX;
			this.swipeEnd();
		}
	}
};
</script>

<style>
.slider-nav {
	width: 250px;
	margin-top: -22.5px;
}

@media screen and (min-width: 992px) {
	.slider-nav {
		width: auto;
		margin-top: auto;
		position: absolute;
		left: 80px;
		right: 80px;
		top: 50%;
		transform: translateY(-50%);
	}
}
</style>
